export default "__VITE_ASSET__B$NdBwKb__"